module.exports = __webpack_public_path__ + "static/img/ground5.0a54aa98.png";